<template>
  <div class="facebook-page-list">
    <div class="form-card">
      <div class="text-center">
        <h1>Connect Facebook Page</h1>
        <p class="permission-notification">
          We’ll need permissions to manage your Page’s messages in order to send invoices.
        </p>
      </div>
      <b-col
        v-if="pagesExist"
        md="12"
        class="fb-list">
        <b-row
          v-for="page in pages"
          :key="page.id">
          <b-col
            md="12"
            class="page-item">
            <div class="page-details">
              <img
                :src="page.picture"
                class="img-responsive">
              <span
                class="page-name">
                {{ page.name }}
              </span>
            </div>
            <div class="connect-button">
              <a
                class="btn btn-connect btn-round"
                @click="connectPage(page)">
                Connect
              </a>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        v-else=""
        md="12"
        class="fb-list no-pages">
        <b-row>
          <b-col
            md="12"
            class="text-center">
            <p>You don't have any pages created.</p>
            <a href="https://www.facebook.com/pages/create/">
              <icon
                name="plus"
                width="10"
                height="10"/>
              Create new Facebook Page
            </a>
          </b-col>
        </b-row>
      </b-col>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FbPageList',
  props: {
    pagesp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pages: [],
    };
  },
  computed: {
    pagesExist() {
      return !!this.pagesp.length;
    },
  },
  created() {
    if (this.pagesp.length) {
      this.pagesp.forEach((page) => {
        const pageData = {
          id: page.id,
          access_token: page.access_token,
          name: page.name,
          picture: '',
        };

        window.FB.api(`/${page.id}/picture`, {
          redirect: 0,
        }, (response) => {
          if (response && !response.error) {
            pageData.picture = response.data.url;
          }
        });

        this.pages.push(pageData);
      });
    }
  },
  methods: {
    connectPage(page) {
      this.$emit('connectPage', page);
    },
  },
};
</script>
